/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * RedirectToWmapSubmitPayment Input Action
 */
export class RedirectToWmapSubmitPaymentInput implements Msdyn365.IActionInput {
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `RedirectToWmapSubmitPayment`;
    public getCacheObjectType = () => 'RedirectToWmapSubmitPayment';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

export interface IRedirectToWmapSubmitPaymentData {
    redirectToWmapSubmitPayment: boolean;
}

/**
 *   Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new RedirectToWmapSubmitPaymentInput();
};

/**
 *   Use this function to call your action and process the results as needed
 */
async function action(input: RedirectToWmapSubmitPaymentInput, ctx: Msdyn365.IActionContext): Promise<IRedirectToWmapSubmitPaymentData> {
    return { redirectToWmapSubmitPayment: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IRedirectToWmapSubmitPaymentData>>action,
    id: 'RedirectToWmapSubmitPayment',
    input: createInput
});
